import Vue from 'vue'

export default {
  list (config = {}) {
    return Vue.http.get('/licensor/products', {
      ...config
    })
  },

  get (id, config = {}) {
    return Vue.http.get(`/licensor/products/${id}`, {
      ...config
    })
  },

  getAll (config = {}) {
    return Vue.http.get('/licensor/product_sales', {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/licensor/product.js